import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Chip from "@mui/material/Chip";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useEffect, useState } from "react";
import "./RefundList.css";
import {
  TableFooter,
  TablePagination,
  CircularProgress,
  Box,
  Divider,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useGetList } from "../../hooks/useGetList";
import formatDate from "../../utils/formatDate";
import { Calendar } from "lucide-react";
import { setLimit, setPage } from "../../redux/refundRequest/filterSlice";
import { usePost } from "../../hooks/usePost";
import buildParams from "../../utils/buildParams";

const RefundList = () => {
  const [approveModal, setApproveModal] = useState({
    open: false,
    refund: null,
  });
  const [declineModal, setDeclineModal] = useState({
    open: false,
    refund: null,
  });

  const filter = useSelector((state) => state.refundRequest);
  const dispatch = useDispatch();

  const params = buildParams(filter);
  const { data, loading, fetchData, refetch } = useGetList(
    "refund-requests",
    true,
    Object.keys(params).length ? params : undefined,
  );
  const { loading: postLoading, postData } = usePost(
    approveModal.refund?.relatedTreatmentVoucher?._id
      ? `ho/refund-request/approve/treatment-voucher/${approveModal?.refund?.relatedTreatmentVoucher?._id}`
      : null,
  );

  const { loading: declineLoading, postData: declinePostData } = usePost(
    `ho/refund-request/reject/${declineModal?.refund?._id}`,
  );

  const getStatusColor = (status) => {
    switch (status) {
      case "Finished":
        return { bgcolor: "#e8f5e8", color: "#2e7d32" };
      case "Declined":
        return { bgcolor: "#ffebee", color: "#d32f2f" };
      case "Pending":
        return { bgcolor: "#fff3e0", color: "#f57c00" };
      default:
        return { bgcolor: "#f5f5f5", color: "#666" };
    }
  };

  const handleApprove = (refund) => {
    console.log("refund", refund);

    setApproveModal({ open: true, refund });
  };
  const handleDecline = (refund) => {
    setDeclineModal({ open: true, refund });
  };

  const confirmApprove = async () => {
    const { refundPayloads, _id } = approveModal.refund;
    const payload = {
      ...refundPayloads,
      refundRequestId: _id,
    };

    setApproveModal({ open: false, refund: null });

    const result = await postData(payload, {
      successMessage: "Refund approved successfully!",
    });

    if (result) {
      console.log("Refund approved successfully");
    }
    await refetch();
  };

  const confirmDecline = async () => {
    await declinePostData({});
    setDeclineModal({ open: false, refund: null });
    await refetch();
  };

  const closeApproveModal = () => {
    setApproveModal({ open: false, refund: null });
  };

  const closeDeclineModal = () => {
    setDeclineModal({ open: false, refund: null });
  };

  const handleChangePage = (e, page) => {
    dispatch(setPage(page + 1));
  };
  const handleChangeRowsPerPage = (e) => {
    dispatch(setLimit(e.target.value));
    dispatch(setPage(1));
  };

  useEffect(() => {
    const params = buildParams(filter);
    fetchData(
      "refund-requests",
      Object.keys(params).length ? params : undefined,
    );
  }, [filter]);

  console.log(filter);

  return (
    <Paper sx={{ width: "100%" }}>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          overflow: "scroll",
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="refund list table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
                Refund Code
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
                Voucher Code
              </TableCell>

              {/* <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
              Date
            </TableCell> */}
              <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
                Status
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
                Refund Type
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
                Refund Method
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
                Refund Amount
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
                Reason
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#333" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <CircularProgress size={30} sx={{ color: "#1976d2" }} />
                    <div>Loading refund requests...</div>
                  </Box>
                </TableCell>
              </TableRow>
            ) : data?.data?.length > 0 ? (
              data?.data?.map((row) => (
                <TableRow
                  key={row._id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": { backgroundColor: "#f9f9f9" },
                    transition: "background-color 0.2s ease-in-out",
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      // fontFamily: "monospace",
                      // fontWeight: "medium",
                      width: "180px",
                      maxWidth: "180px",
                      minWidth: "180px",
                    }}
                  >
                    <div className="d-flex flex-column g-2">
                      {row.code || "N/A"}
                      <p className="date">
                        <Calendar className="size-10 text-gray-500" />
                        <span className="text-sm text-gray-500">
                          {formatDate(row.createdAt)}
                        </span>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontFamily: "monospace",
                      color: "#1976d2",
                      width: "220px",
                      maxWidth: "220px",
                      minWidth: "220px",
                    }}
                  >
                    {row?.relatedTreatmentVoucher?.code}
                  </TableCell>

                  {/* <TableCell>{row.createdAt}</TableCell> */}
                  <TableCell>
                    <Chip
                      label={row.status}
                      size="small"
                      sx={{
                        fontWeight: "medium",
                        ...getStatusColor(row.status),
                      }}
                    />
                  </TableCell>
                  <TableCell>{row.refundType}</TableCell>
                  <TableCell
                    sx={{
                      width: "180px",
                      maxWidth: "180px",
                      minWidth: "180px",
                    }}
                  >
                    <div>
                      <div>{row.refundPaymentType}</div>
                      <div style={{ fontSize: "0.85em", color: "#666" }}>
                        {row.relatedRefundAccount?.subHeader || "N/A"}
                      </div>
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      width: "180px",
                      maxWidth: "180px",
                      minWidth: "180px",
                    }}
                  >
                    {row.refundPayloads?.totalRefundAmount.toLocaleString()}{" "}
                    MMK{" "}
                  </TableCell>

                  <TableCell
                    sx={{
                      maxWidth: 300,
                      wordWrap: "break-word",
                      width: "180px",
                      maxWidth: "180px",
                      minWidth: "180px",
                    }}
                  >
                    {row.refundReason?.length > 100
                      ? `${row.refundReason.substring(0, 100)}...`
                      : row.refundReason}
                  </TableCell>
                  <TableCell>
                    {row.status === "Pending" && (
                      <div style={{ display: "flex", gap: "8px" }}>
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={<CheckCircleIcon />}
                          onClick={() => handleApprove(row)}
                          sx={{
                            backgroundColor: "#4caf50",
                            "&:hover": { backgroundColor: "#45a049" },
                            textTransform: "none",
                            fontSize: "0.85rem",
                          }}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={<CancelIcon />}
                          onClick={() => handleDecline(row)}
                          sx={{
                            backgroundColor: "#f44336",
                            "&:hover": { backgroundColor: "#da190b" },
                            textTransform: "none",
                            fontSize: "0.85rem",
                          }}
                        >
                          Decline
                        </Button>
                      </div>
                    )}
                    {row.status === "Finished" && (
                      <Chip
                        label="Finished"
                        size="small"
                        sx={{
                          bgcolor: "#e8f5e8",
                          color: "#2e7d32",
                          fontWeight: "medium",
                        }}
                      />
                    )}
                    {row.status === "Declined" && (
                      <Chip
                        label="Declined"
                        size="small"
                        sx={{
                          bgcolor: "#ffebee",
                          color: "#d32f2f",
                          fontWeight: "medium",
                        }}
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  There is no refund request...
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Divider sx={{ my: 2 }} />

        {/* Approve Confirmation Modal */}
        <Dialog
          open={approveModal.open}
          onClose={closeApproveModal}
          aria-labelledby="approve-dialog-title"
          aria-describedby="approve-dialog-description"
        >
          <DialogTitle id="approve-dialog-title">
            Confirm Refund Approval
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="approve-dialog-description">
              Are you sure you want to approve this refund request?
              <br />
              <br />
              <strong>Refund ID:</strong> {approveModal.refund?.code}
              <br />
              <strong>Voucher Code:</strong>{" "}
              {approveModal.refund?.relatedTreatmentVoucher?.code}
              <br />
              <strong>Amount:</strong> {approveModal.refund?.refundType}
              <br />
              <strong>Reason:</strong> {approveModal.refund?.refundReason}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeApproveModal} color="secondary">
              Cancel
            </Button>
            <Button
              onClick={confirmApprove}
              variant="contained"
              sx={{
                backgroundColor: "#4caf50",
                "&:hover": { backgroundColor: "#45a049" },
              }}
              autoFocus
              disabled={postLoading}
            >
              {postLoading ? (
                <CircularProgress size={24} sx={{ mr: 1 }} />
              ) : (
                "Approve"
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Decline Confirmation Modal */}
        <Dialog
          open={declineModal.open}
          onClose={closeDeclineModal}
          aria-labelledby="decline-dialog-title"
          aria-describedby="decline-dialog-description"
        >
          <DialogTitle id="decline-dialog-title">
            Confirm Refund Decline
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="decline-dialog-description">
              Are you sure you want to decline this refund request?
              <br />
              <br />
              <strong>Refund ID:</strong> {declineModal.refund?.code}
              <br />
              <strong>Voucher Code:</strong>{" "}
              {declineModal.refund?.relatedTreatmentVoucher?.code}
              <br />
              <strong>Amount:</strong> {declineModal.refund?.refundType}
              <br />
              <strong>Reason:</strong> {declineModal.refund?.reason}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDeclineModal} color="secondary">
              Cancel
            </Button>
            <Button
              onClick={confirmDecline}
              variant="contained"
              sx={{
                backgroundColor: "#f44336",
                "&:hover": { backgroundColor: "#da190b" },
              }}
              autoFocus
              disabled={declineLoading}
            >
              {declineLoading ? (
                <CircularProgress size={24} sx={{ mr: 1 }} />
              ) : (
                "Decline"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15, 20, 25, 100]}
        component="div"
        count={data?.metadata?.total || 0}
        rowsPerPage={filter.limit}
        page={filter.page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",

          "& .MuiTablePagination-toolbar": {
            display: "flex",
            alignItems: "center",
            minHeight: "52px",
          },

          "& .MuiTablePagination-selectLabel": {
            margin: 0,
            display: "flex",
            alignItems: "center",
          },

          "& .MuiTablePagination-displayedRows": {
            margin: 0,
            display: "flex",
            alignItems: "center",
          },

          "& .MuiTablePagination-actions": {
            display: "flex",
            alignItems: "center",
          },
        }}
      />
    </Paper>
  );
};
export default RefundList;
